import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import properties from'../../constants/Properties';
import locales from '../../locales/LocalesManager';
import mouseUtils from '../utils/MouseUtils';
import playController from '../utils/PlayController';
import { changeAudioTabIndex } from '../../actions/MenuActions';
import { SlideSoundsBrowser } from '../../components/menus/SlideSoundsBrowser';
import { StorySoundsBrowser } from '../../components/menus/StorySoundsBrowser';
import { AdvancedSoundsBrowser } from '../../components/menus/AdvancedSoundsBrowser';
import videoUtils from '../utils/VideoUtils';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        videoUtils.executeAction('reset');
        playController.checkAudioEditorMode();
    },
    render() {
        var textColor;
        var gap = properties.AUDIO_EDITOR_BUTTON_GAP;

        if (this.state.isOver)
            textColor = '#2299D6';
        else
            textColor = 'white';

        var tabStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth - 2 * gap,
            height: properties.CLIPART_BUTTON_HEIGHT,
            left: gap,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        if (this.props.audioTabIndex == 0 || this.props.audioTabIndex == 1)
            tabStyle.bottom = gap;
        else
            tabStyle.top = 2 * properties.BROWSER_BUTTON_HEIGHT + gap;

        const spanStyle = {
            color: textColor,
            fontSize: 15,
            position: 'absolute',
            top: 6,
            width: tabStyle.width - 4,
            left: 2,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center',
            cursor: 'default'
        };

        return (
            <button aria-label={locales.getCaption('AudioEditMode', 'save')} style={tabStyle} onClick={this.onClick} onTouchEnd={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <span style={spanStyle}>{locales.getCaption('AudioEditMode', 'save')}</span>
            </button>
        );
    }
});

const TabElement = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;
        const state = storeManager.getState();
        const audioTabIndex = state.menu.audioTabIndex;

        if (this.props.index == audioTabIndex)
            dispatch(changeAudioTabIndex(-1));
        else
            dispatch(changeAudioTabIndex(this.props.index));
    },
    render() {
        let topPosition = properties.BROWSER_BUTTON_HEIGHT * this.props.index;

        if (this.props.audioTabIndex == 0 && this.props.index == 1) {
            topPosition = this.props.windowHeight - 2 * properties.CLIPART_BUTTON_HEIGHT -  2 * properties.AUDIO_EDITOR_BUTTON_GAP - properties.BROWSER_BUTTON_HEIGHT;
        }

        var buttonColor;
        var textColor;
        var icon;
        var iconColor;

        if (this.props.index == this.props.audioTabIndex) {
            buttonColor = properties.BROWSER_SELECTED_COLOR;
            textColor = '#F7F7F7';
            icon = 'fa fa-angle-down';
            iconColor = 'white';
        }
        else {
            icon = 'fa fa-angle-right';
            iconColor = 'black';

            if (this.state.isOver == true) {
                buttonColor = properties.BROWSER_HOVER_COLOR;
                textColor = '#2299D6';
            } else {
                buttonColor = properties.BROWSER_COLOR;
                textColor = '#000000';
            }
        }

        const tabStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth - 1,
            height: properties.BROWSER_BUTTON_HEIGHT,
            paddingLeft: properties.BROWSER_LEFT_PADDING,
            top: topPosition,
            color: 'white',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none',
            margin: 0,
            paddingRight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            textAlign: 'left',
            borderStyle: 'none'
        };

        const spanStyle = {
            position: 'absolute',
            top: 5,
            color: textColor,
            fontSize: 15,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        const iconStyle = {
            position: 'absolute',
            top: 6,
            right: properties.BROWSER_LEFT_PADDING + properties.BROWSER_ICON_RIGHT_PADDING,
            color: iconColor
        };

        var text;

        if (this.props.index == 0)
            text = locales.getCaption('StorySoundTab', 'music');
        else
            text = locales.getCaption('SlideSoundTab', 'music');

        const topLine = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: tabStyle.width,
            height: 1,
            background: 'white'
        };

        return (
            <button aria-label={text} style={tabStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onClick} onTouchEnd={this.onClick}>
                <div style={topLine}></div>
                <span style={spanStyle}>{text}</span>
                <i style={iconStyle} className={icon}></i>
            </button>
        );
    }
});

const AudioTabContent = React.createClass({
    render() {
        const tabStyle = {
            position: 'absolute',
            width: this.props.accordionWidth,
            height: this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT,
            top: properties.CLIPART_BUTTON_HEIGHT,
            background: 'white'
        };

        var top;
        var height;

        if (playController.isAudioEditorAvailable()) {
            top = 0;
            height = tabStyle.height;

            return (
                <div style={tabStyle}>
                    <audio id='audioBrowserSound' className='audioItem' preload='auto' playsInline/>
                    <AdvancedSoundsBrowser height={height} top={top} accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowHeight={this.props.windowHeight}/>
                </div>
            );
        } else {
            if (this.props.clipartCategory != 2)
                return (<div/>);

            var browserElement;

            if (this.props.audioTabIndex == 0 || this.props.audioTabIndex == 1) {
                height = tabStyle.height - 2 * properties.BROWSER_BUTTON_HEIGHT - 2 * properties.AUDIO_EDITOR_BUTTON_GAP - properties.CLIPART_BUTTON_HEIGHT;

                if (this.props.audioTabIndex == 1) {
                    top = 2 * properties.BROWSER_BUTTON_HEIGHT;

                    browserElement =
                        <SlideSoundsBrowser height={height} top={top} accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowHeight={this.props.windowHeight}/>;
                } else {
                    top = properties.BROWSER_BUTTON_HEIGHT;

                    browserElement =
                        <StorySoundsBrowser height={height} top={top} accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowHeight={this.props.windowHeight}/>;
                }
            }

            return (
                <div style={tabStyle}>
                    <audio id='audioBrowserSound' className='audioItem' preload='auto' playsInline/>
                    <TabElement accordionWidth={this.props.accordionWidth} index={0} audioTabIndex={this.props.audioTabIndex} windowHeight={this.props.windowHeight}/>
                    <TabElement accordionWidth={this.props.accordionWidth} index={1} audioTabIndex={this.props.audioTabIndex} windowHeight={this.props.windowHeight}/>
                    <Button accordionWidth={this.props.accordionWidth} audioTabIndex={this.props.audioTabIndex}/>
                    {browserElement}
                </div>
            );
        }
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var clipartCategory = state.menu.clipartCategory;
    var audioTabIndex = state.menu.audioTabIndex;
    var showAudioEditor = state.menu.showAudioEditor;

    if (clipartCategory == undefined)
        clipartCategory = 0;

    if (audioTabIndex == undefined)
        audioTabIndex = -1

    return {
        clipartCategory,
        audioTabIndex,
        showAudioEditor
    };
}

export const AudioTab = connect(mapStateToProps)(AudioTabContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/AudioTab.js
 **/